var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Autocomplete, Checkbox, Chip, createFilterOptions, ListItemText, TextField, Typography } from '@mui/material';
import React from 'react';
const baseFilter = createFilterOptions({
    stringify: (option) => (option === null || option === void 0 ? void 0 : option.name) || '',
});
/**
 * Фильтр по имени, порядок списка стабильный (алфавит).
 * Выбранные не поднимаем вверх при каждом клике — иначе список «прыгает».
 * Выбранные видны чипами в поле и галочками в списке.
 */
export function filterTransportGroups(options, params) {
    const filtered = baseFilter(options, params);
    return [...filtered].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'ru'));
}
/** Высота OutlinedInput как у TextField/Select size="small" (не denser Autocomplete). */
const matchSmallTextFieldSx = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        minHeight: 40,
        alignItems: 'center',
        py: 0,
    },
    '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
        paddingTop: '8.5px',
        paddingBottom: '8.5px',
    },
};
function TransportGroupsAutocomplete({ options = [], value = [], onChange, disabled = false, label, helperText, placeholder = 'Поиск группы…', size = 'small', sx, disableClearable = true, limitTags, }) {
    return (React.createElement(Autocomplete, { multiple: true, disableCloseOnSelect: true, disableClearable: disableClearable, disabled: disabled, size: size, options: options, value: value || [], onChange: (_, next) => onChange === null || onChange === void 0 ? void 0 : onChange(next || []), filterOptions: filterTransportGroups, getOptionLabel: (option) => (option === null || option === void 0 ? void 0 : option.name) || '', isOptionEqualToValue: (option, selected) => option.id === selected.id, limitTags: limitTags, getLimitTagsText: (more) => `+${more}`, noOptionsText: React.createElement(Typography, { variant: 'body2' }, "\u041D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0433\u0440\u0443\u043F\u043F"), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { size: size, label: label, helperText: helperText, placeholder: placeholder, inputProps: Object.assign(Object.assign({}, params.inputProps), { 'aria-label': label || 'Транспортные группы' }) }))), renderTags: (tagValue, getTagProps) => tagValue.map((option, index) => {
            var _a;
            const _b = getTagProps({ index }), { key } = _b, tagProps = __rest(_b, ["key"]);
            return React.createElement(Chip, Object.assign({ key: (_a = option.id) !== null && _a !== void 0 ? _a : key, label: option.name, size: 'small' }, tagProps));
        }), renderOption: (props, option, { selected }) => {
            var _a;
            const { key } = props, optionProps = __rest(props, ["key"]);
            return (React.createElement("li", Object.assign({ key: (_a = option.id) !== null && _a !== void 0 ? _a : key }, optionProps),
                React.createElement(Checkbox, { size: 'small', checked: selected, tabIndex: -1, disableRipple: true, sx: { mr: 1, p: 0.5 } }),
                React.createElement(ListItemText, { primary: option.name })));
        }, ListboxProps: {
            style: {
                maxHeight: 300,
                overflow: 'auto',
            },
        }, sx: Object.assign(Object.assign({}, matchSmallTextFieldSx), sx) }));
}
export default TransportGroupsAutocomplete;
